/* eslint-disable no-unused-expressions */
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import InputForm from "../Input/input";
import { validEmailRegex, validPasswordRegex } from "../../utils/variables";

const weakPasswordDefinition = "Your password must have at least eight characters, one uppercase letter, one lowercase letter, one number and one special character";

const commonPasswords = require("../../utils/common-passwords.json");

class Form extends Component {
  state = { credentials: {}, errors: {} };

  validate() {
    const { credentials } = { ...this.state };
    var error = false;
    for (let [name, value] of Object.entries(credentials)) {
      switch (name) {
        case "name":
          value.length < 3 ? (error = true) : "";
          break;
        case "email":
          validEmailRegex.test(value) ? "" : (error = true);
          break;
        case "password":
          validPasswordRegex.test(value) && !commonPasswords.includes(value) ? "" : (error = true);
          break;
        case "repeatPassword":
          value !== this.state.credentials.password || value === ""
            ? (error = true)
            : "";
          break;
        default:
          break;
      }
    }
    if (!error) return false;
    else return true;
  }

  validateProperty = ({ name, value }) => {
    const errors = { ...this.state.errors };
    switch (name) {
      case "name":
        errors.name =
          value.length < 3 ? "Name must be 3 characters long!" : null;
        break;
      case "email":
        errors.email = validEmailRegex.test(value)
          ? null
          : "Email is not valid!";
        break;
      case "password":
        errors.password = !validPasswordRegex.test(value) 
        ? weakPasswordDefinition : 
        commonPasswords.includes(value)
          ? "Password present in list of compromised or common passwords!"
          : null;
        break;
      case "repeatPassword":
        errors.repeatPassword =
          value !== this.state.credentials.password || value === ""
            ? "Passwords don't match"
            : null;
        break;
      default:
        break;
    }
    return errors[name];
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const credentials = { ...this.state.credentials };
    credentials[input.name] = input.value;
    this.setState({ credentials, errors });
  };
  renderButton(label) {
    return (
      <Button
        type="submit"
        style={{
          background: "#34b4eb",
          color: "#fff",
          width: "200px",
          textAlign: "center"
        }}
        disabled={this.validate()}
      >
        {label}
      </Button>
    );
  }
  renderInput(name, type, label, placeholder = "Password here...") {
    const { credentials, errors } = this.state;
    return (
      <InputForm
        type={type}
        name={name}
        value={credentials[name]}
        placeholder={placeholder}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/common/Form/form.jsx